import React from "react";
import "./Footer.css"; 

const Footer = () => {
  return (
    <footer className="footer">
        For assistance or inquiries regarding this tool, please reach out to Walmart.INDTRV.ProjectManagers@ust.com.
        © 2022 UST INC. | All rights reserved.
      
    </footer>
  );
};

export default Footer;
